import styled from 'styled-components';

interface iDefault {
  defaultValue: string | null;
}

export const InputSearch = ({
  handleChange,
  inputValue,
  handleKeyPress,
}: iDefault) => {
  return (
    <Wrapper>
      <Label htmlFor="inputId"></Label>

      <Input
        type="text"
        id="inputId"
        placeholder="Search.."
        value={inputValue ?? ''}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e6e8ec;
  background: #fff;
  display: flex;
  width: 300px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-size: 14px;
  &::placeholder {
    color: #b1b5c3;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;
const Label = styled.label`
  visibility: hidden;
  height: 0;
`;
